<template>
    <img src="/assets/DENTCloud.svg" alt="DentCloud" />
</template>